import { render, staticRenderFns } from "./ExtrudePanel.vue?vue&type=template&id=f815b78c"
import script from "./ExtrudePanel.vue?vue&type=script&lang=ts"
export * from "./ExtrudePanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports